import React from "react";

import "./index.scss";

const NextIcon = props => {
  const style = props?.type || "default";
  const height = props?.height || "32";
  const width = props?.width || "32";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" className="next-btn-container">
      <g id="Arrow" transform="translate(-2 0) rotate(0)">
        <rect id="Margin" width="32" height="32" fill="none" />
        <g id="Path_8647" data-name="Path 8647" className={style}>
          <path
            d="M 14.84370422363281 22.95144271850586 L 14.73763465881348 22.84538269042969 L 13.89462471008301 22.00237274169922 L 13.78855419158936 21.89629364013672 L 13.89463424682617 21.79023361206055 L 18.9460620880127 16.73949241638184 L 13.89394474029541 11.68840312957764 L 13.78781414031982 11.58229351043701 L 13.8939847946167 11.4762134552002 L 14.73768424987793 10.63320350646973 L 14.84375476837158 10.52722358703613 L 14.94977474212646 10.63325309753418 L 20.94960403442383 16.6334228515625 L 21.0556640625 16.73948287963867 L 20.94960403442383 16.84555244445801 L 14.94977474212646 22.84538269042969 L 14.84370422363281 22.95144271850586 Z"
            stroke="none"
          />
          <path
            className="next-btn"
            d="M 14.84370422363281 22.73931312561035 L 20.84353446960449 16.73948287963867 L 14.84370422363281 10.73931312561035 L 14.00000476837158 11.58232307434082 L 19.1582145690918 16.73948287963867 L 14.00069427490234 21.89630317687988 L 14.84370422363281 22.73931312561035 M 14.84370422363281 23.16357231140137 L 13.57641410827637 21.89629364013672 L 18.73391342163086 16.7394847869873 L 13.57563400268555 11.58225345611572 L 14.84379482269287 10.3151330947876 L 21.26779365539551 16.73949241638184 L 14.84370422363281 23.16357231140137 Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default NextIcon;
